import React from "react";
//eslint-disable-next-line no-unused-vars
import PT from "prop-types";
import { SocialMedias } from "./othercontrols";
import { ResponsivenessGrid, Footer, FooterColumn, FooterNote, FooterTitle, FooterItemList, FooterSubTitle, FooterLabel } from "../toolkit";
import Moment from "moment";
import { map } from "lodash";
import TranslatorManager from 'ts-translate-js';

const tr = TranslatorManager.boundTR;

const controlsByType = {
    menu: FooterMenu,
    politics: FooterPolitics,
    businessHours: FooterBusinessHours,
    contactDetails: FooterContactDetails
};

function buildFooterSections(sections) {
    return map(sections, section => {
        const FooterSection = controlsByType[section.type];
        return <FooterSection section={section} />;
    });
}

export function SiteFooter({ sections, lang }) {
    const currentYear = Moment().year();
    const langToDisplay = lang === "en-US" ? tr("Français") : tr("English");
    const langToChange = lang === "en-US" ? "fr-CA" : "en-US";

    const footerSections = buildFooterSections(sections);
    
    return (
        <Footer classNames="row-content-with-padding">
            <ResponsivenessGrid breakpointsConfigs={{ mobile: 655, tablet: 800, small: 1280, large: 50000 }}
                                nbrColumnsByBreakpointConfigs={{ mobile:1, tablet:2, small:2, large: 4 }}
                                items={footerSections}
            />
            <div
                dangerouslySetInnerHTML={{
                    __html:
                    `
                        <button 
                            class="mdc-button rese-button smaller-font-size no-letter-spacing simple-rese-button simple-rese-button--white" 
                            onclick="tsapp.changeLang('${langToChange}')"
                        >
                            ${langToDisplay}
                        </button>
                    `
                }}
            >
                
            </div>

            <FooterColumn fullWidth={true}>
                <FooterNote>
                    <span className="copyright">{tr("© {currentYear} Reservatech | Tous droits réservés", { currentYear: currentYear })}</span>
                </FooterNote>
            </FooterColumn>
        </Footer>
    );
}
SiteFooter.propTypes = {
    tr: PT.func,
    integ: PT.string,
    sections: PT.array,
    lang: PT.string,
};

function FooterMenu({ section }) {
    return (
        <FooterColumn>
            <FooterTitle>{section.title}</FooterTitle>

            <FooterItemList spaced={true}>
                {map(section.items, (item, i) => <a key={i} href={item.url}>{item.value}</a>)}
            </FooterItemList>
            
        </FooterColumn>
    );
}
FooterMenu.propTypes = {
    section: PT.shape({
        title: PT.string,
        items: PT.array
    })
};

function FooterPolitics({ section }){
    return (
        <FooterColumn>
            <FooterTitle>{section.title}</FooterTitle>

            <FooterItemList spaced={true}>
                {map(section.items, (item, i) => <a key={i} href={item.url}>{item.value}</a>)}
            </FooterItemList>

        </FooterColumn>
    );
}
FooterPolitics.propTypes = {
    section: PT.shape({
        title: PT.string,
        items: PT.array
    })
};

function FooterBusinessHours({ section }) {
    return <FooterColumn>
        <FooterTitle>{section.title}</FooterTitle>
        
        {
            map(section.items, (subSection, i) =>
                <div key={i}>
                    <FooterSubTitle>{subSection.title}</FooterSubTitle>
                    <FooterItemList>
                        {map(subSection.items, (item, i) => <FooterLabel key={i}>{item.value}</FooterLabel>)}
                    </FooterItemList>
                    <br/>
                </div>)
        }
        
    </FooterColumn>;
}
FooterBusinessHours.propTypes = {
    section: PT.shape({
        title: PT.string,
        items: PT.array
    })
};

export function FooterContactDetails({ section }) {
    const phones = section.items.phones;
    const address = section.items.address;
    const socialMedias = section.items.socialMedias;

    let socialMediasSection = null;

    if (socialMedias != undefined) {
        socialMediasSection = <FooterColumn>
            <br/>
            <SocialMedias {...socialMedias} />
        </FooterColumn>;
    }
    
    return <FooterColumn>
        <FooterTitle>{tr("Nos coordonnées")}</FooterTitle>

        <FooterItemList>
            {map(phones, (phone, i) => <FooterLabel key={i}>{phone.value}</FooterLabel>)}
        </FooterItemList>

        <FooterItemList>
            <FooterLabel>{address.address1}</FooterLabel>
            <FooterLabel>{address.address2}</FooterLabel>
            <FooterLabel>{address.city + " " + address.province + " " + address.postalCode}</FooterLabel>
        </FooterItemList>

        {socialMediasSection}

    </FooterColumn>;
}
FooterContactDetails.propTypes = {
    section: PT.shape({
        title: PT.string, 
        items: PT.shape({
            phones: PT.arrayOf(PT.objectOf(PT.string)),
            address: PT.shape({
                address1: PT.string,
                address2: PT.string,
                city: PT.string,
                province: PT.string, 
                country: PT.string,
                postalCode: PT.string
            }),
            socialMedias: PT.shape({
                facebook: PT.string,
                twitter: PT.string
            })
        })
    })
};
